import React, { useCallback, useMemo } from "react";


import { LOCAL_STORAGE_TRAFFIC_STAT_FILTERS_DIALER, transformed_service_data } from "const";
import { withTranslation } from "hoc/WithTranslation";
import { getFormattedTimeIOS } from "utils";
import {
    getISOTime,
    getAllowedRangesByIntervalMonth
} from "utils/helpers";
import m from "definedMessages";
import CommonTable from "components/Payments/CommonPaymentsTable";
import * as S from "../styled.js";

import { Table, Tooltip } from "rsuite";
import Whisper from "components/Whisper";

const { Column, HeaderCell, Cell } = Table;


const PaymentsTrafficReportsTable = ({
    data = [],
    loading = false,
    openModalRequestPayment,
    currencyName,
    accountJoinList,
    globalSettings,

    formatMessage
}) => {

    const uniqueAccountList = useMemo(() => {
        const key = "service";
        return [...new Map((accountJoinList || []).map(item => [item[key], item])).values()];
    }, [accountJoinList]);

    const columns = useMemo(() => {
        const statusLabels = [
            formatMessage(m.pending),
            formatMessage(m.readyForPayment),
            formatMessage(m.paid),
        ];

        return [
            {
                id: "trafficPeriod",
                label: formatMessage(m.trafficPeriod),
                value: ({ date_from, date_to }) => `${getFormattedTimeIOS(date_from)} - ${getFormattedTimeIOS(date_to)}`,
                flexGrow: 2,
                minWidth: 200,
                align: "center"
            },
            {
                id: "date",
                label: formatMessage(m.date),
                dataKey: "date2",
                flexGrow: 2,
                minWidth: 200,
                align: "center"
            },
            {
                id: "amount",
                label: formatMessage(m.amount),
                value: ({ agr_send }) => `${agr_send}${currencyName ? " " + currencyName : ""}`,
                flexGrow: 2,
                minWidth: 200,
                align: "center"
            },
            {
                id: "status",
                label: formatMessage(m.status),
                value: ({ status }) => statusLabels[status] || status,
                flexGrow: 2,
                minWidth: 200,
                align: "center"
            },
            {
                id: "service",
                label: formatMessage(m.service),
                value: ({ service }) => service,
                flexGrow: 2,
                minWidth: 150,
                width: 287,
                align: "center"
            }
        ];

    }, [currencyName, formatMessage]);

    const showDetails = useCallback((rowData) => {
        const serviceType = transformed_service_data[rowData?.service];
        const isKnownService = serviceType !== undefined;
        const serviceName = isKnownService ? rowData.service : "voice";
        const isVoiceService = Boolean(serviceType);

        const dateFrom = new Date(rowData.date_from);
        const dateTo = new Date(rowData.date_to);

        const checkbox = isVoiceService
            ? ["range", "a_number", "b_number", "month", "b_destination"]
            : ["range", "senderid", "phone", "month", "destination"];

        const filtersDefaultValue = isVoiceService ? {
            group: checkbox.join("/"),
            checkbox,
            start_date: getISOTime(dateFrom),
            end_date: getISOTime(dateTo),
            range: [dateFrom, dateTo]
        } : {
            group: checkbox.join("/"),
            checkbox,
            start_date: getISOTime(dateFrom),
            end_date: getISOTime(dateTo),
            range: [dateFrom, dateTo]
        };

        localStorage.setItem(LOCAL_STORAGE_TRAFFIC_STAT_FILTERS_DIALER, JSON.stringify(filtersDefaultValue));
        const mainPath = uniqueAccountList.length > 1 ? `/traffic-${serviceName}` : "/traffic";
        window.open(`${mainPath}?type=traffic_reports`);
    }, [uniqueAccountList]);

    const allowedRanges = useMemo(() => {
        return globalSettings
            ? getAllowedRangesByIntervalMonth(globalSettings.cdr_full__interval_month)
            : null;
    }, [globalSettings]);

    const tableActions = useMemo(() => (
        <Column width={210} key="table__actions">
            <HeaderCell> </HeaderCell>
            <Cell>
                {rowData => {

                    const dateFrom = new Date(rowData.date_from);
                    const startDateYmd = `${dateFrom.getFullYear()}${("0" + (dateFrom.getMonth() + 1)).slice(-2)}${("0" + dateFrom.getDate()).slice(-2)}`;

                    return (
                        <S.StyledTableActions alignEnd>

                            {rowData.status === 1 &&
                                <S.StyledTableButton
                                    onClick={openModalRequestPayment}
                                >
                                    {formatMessage(m.requestPayment)}
                                </S.StyledTableButton>
                            }

                            {allowedRanges && startDateYmd < allowedRanges[0]
                                ?
                                <Whisper
                                    preventOverflow
                                    trigger="hover"
                                    speaker={<Tooltip>{formatMessage(m.cdrHistoryPeriodIs, { count: globalSettings && globalSettings.cdr_full__interval_month })}</Tooltip>}
                                    placement="auto"
                                >
                                    <S.StyledTableButton
                                        className="rs-btn-disabled"
                                    >
                                        {formatMessage(m.details)}
                                    </S.StyledTableButton>
                                </Whisper>
                                : <S.StyledTableButton
                                    onClick={() => showDetails(rowData)}
                                >
                                    {formatMessage(m.details)}
                                </S.StyledTableButton>
                            }

                        </S.StyledTableActions>
                    );
                }}
            </Cell>
        </Column>
    ), [formatMessage, showDetails, globalSettings, openModalRequestPayment]);

    return (
        <CommonTable
            data={data}
            loading={loading}
            columns={columns}
            tableActions={tableActions}
        />
    );
};

export default withTranslation(PaymentsTrafficReportsTable);